module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-xs": ""
    }
  }, [_c('v-card', [_c('v-card-text', [_c('v-container', {
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-row', {
    staticClass: "noprint",
    attrs: {
      "wrap": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "headline font-weight-light"
  }, [_vm._v("\n              Use this page to generate printable QR codes.  Enter the tag value into the prompt below and select the QR code size.  Hide the menu during printing for best results.\n            ")])])], 1), _vm._v(" "), _c('v-row', {
    attrs: {
      "wrap": "",
      "id": "printablediv"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "text-xs-center display-2"
  }, [_vm._v("\n            " + _vm._s(_vm.tagString) + "\n            ")])]), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "text-xs-center"
  }, [_c('canvas', {
    ref: "qr"
  })])])], 1), _vm._v(" "), _c('v-row', {
    staticClass: "noprint",
    attrs: {
      "wrap": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('v-combobox', {
    attrs: {
      "label": "Tag",
      "chips": "",
      "deletable-chips": ""
    },
    model: {
      value: (_vm.tags),
      callback: function($$v) {
        _vm.tags = $$v
      },
      expression: "tags"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Code Size",
      "items": _vm.sizes,
      "chips": ""
    },
    model: {
      value: (_vm.size),
      callback: function($$v) {
        _vm.size = $$v
      },
      expression: "size"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-eef279b2","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/QRCode.vue
// module id = 419
// module chunks = 1